import React from 'react';

import * as CreditActions from '../CreditActions';
import * as ActionConstants from '../../../utils/ActionConstants';
import * as CreditConstants from '../CreditConstants';
import CustomInput from '../../../common/components/CustomInput';
import CustomSelect from '../../../common/components/CustomSelect';
import * as Strings from '../../../utils/strings';
import CreditStore from '../CreditStore';
import { serializeForm, isValid } from '../creditUtils';

export default class CreditApplicationStep3 extends React.Component {
    next(e) {
        e.preventDefault();

        const form = serializeForm(this.refs);
        const creditApp = CreditStore.getState();
        if (isValid(this.refs)) {
            if (
                creditApp.yearsInBusiness < 3 ||
                creditApp.businessType === 'Proprietorship'
            ) {
                CreditActions.goTo(CreditConstants.CREDIT_STEP4, { ...form });
            } else {
                CreditActions.goTo(CreditConstants.CREDIT_STEP5, { ...form });
            }
        }
    }
    back = e => {
        e.preventDefault();
        CreditActions.goTo(CreditConstants.CREDIT_STEP2, {});
    };
    render() {
        // Term
        // Cost
        // Asset
        // Condition
        // Age of Asset

        // term: String (12M | 24M | 36M | 48M | 60M | 72M)
        // applicationAmount: Decimal
        // asset: String
        // condition: String (New | Used)
        // ageOfAsset: Integer

        return (
            <div className="credit-application-step">
                <form onSubmit={this.next.bind(this)}>
                    <div className="form-container">
                        <div className="row">
                            <CustomSelect
                                ref="term"
                                label="Term of lease (months)"
                                options={Strings.CREDIT_TERMS}
                            />
                            <CustomInput
                                ref="applicationAmount"
                                type="number"
                                label={Strings.CREDIT_COST}
                                placeholder={Strings.CREDIT_COST_PLACEHOLDER}
                                required
                            />
                        </div>
                        <div className="row">
                            <CustomInput
                                ref="asset"
                                label={Strings.CREDIT_ASSET}
                                placeholder={Strings.CREDIT_ASSET_PLACEHOLDER}
                                required
                            />
                            <CustomSelect
                                ref="condition"
                                label="Condition of asset"
                                options={Strings.CREDIT_ASSET_CONDITION}
                                required
                            />
                        </div>
                        <div className="row">
                            <CustomInput
                                ref="ageOfAsset"
                                type="number"
                                label="Age of asset(in years)"
                                placeholder={3}
                            />
                        </div>
                    </div>
                    <button className="left back-button" onClick={this.back}>
                        Back
                    </button>
                    <button className="right green">
                        {' '}
                        {Strings.CREDIT_BTN_NEXT}
                    </button>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/credit/components/CreditApplicationStep3.jsx